/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ScreenCollapse: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="screen-collapse" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M226.6666666666667 340H680V226.6666666666668H113.3333333333333V623.3333333333334H226.6666666666667V340zM1246.6666666666665 226.6666666666668H793.3333333333333V510H1246.6666666666665V226.6666666666668zM1133.3333333333333 1133.3333333333333C1164.5 1133.3333333333333 1191.1333333333332 1122.2266666666667 1213.3466666666666 1100.0133333333333C1235.56 1077.8 1246.6666666666665 1051.1666666666667 1246.6666666666665 1020V623.3333333333334H1133.3333333333333V1020H623.3333333333333V1133.3333333333333H1133.3333333333333zM396.6666666666667 929.3333333333334V1133.3333333333333H510V736.6666666666667H113.3333333333333V850H317.3333333333333L73.6666666666667 1093.6666666666667L153 1173L396.6666666666667 929.3333333333334z" : "M181.3333333333334 272H544V181.3333333333333H90.6666666666667V498.6666666666666H181.3333333333334V272zM997.3333333333334 181.3333333333333H634.6666666666667V408H997.3333333333334V181.3333333333333zM906.6666666666669 906.6666666666666C931.6000000000003 906.6666666666666 952.9066666666668 897.7813333333334 970.6773333333334 880.0106666666667C988.448 862.24 997.3333333333334 840.9333333333333 997.3333333333334 816V498.6666666666666H906.6666666666669V816H498.6666666666667V906.6666666666666H906.6666666666669zM317.3333333333334 743.4666666666667V906.6666666666666H408V589.3333333333333H90.6666666666667V680H253.8666666666667L58.9333333333333 874.9333333333333L122.4 938.4L317.3333333333334 743.4666666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ScreenCollapse.displayName = `Blueprint5.Icon.ScreenCollapse`;
export default ScreenCollapse;
